import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingCard from './SettingCard';
import BookieCard from './BookieCard';

const SettingsSection = ({ section, onEditSetting }) => {
  const { t } = useTranslation();

  if (!section) {
    return (
      <div className="text-center text-gray-500 py-8">
        No section selected
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Section Header */}
      <div className="bg-[#2A3C29] p-6 rounded-lg">
        <div className="flex items-center space-x-3 mb-2">
          <span className="text-2xl">{section.icon}</span>
          <h2 className="text-xl font-semibold text-[#E8FC8B]">{section.title}</h2>
        </div>
        <p className="text-[#ABCDDF]">{section.description}</p>
      </div>

      {/* Content based on section type */}
      {section.type === 'bookies' ? (
        /* Bookies Grid */
        section.loading ? (
          <div className="text-center text-[#ABCDDF] py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#E8FC8B] mx-auto mb-2"></div>
            {t('loading')}...
          </div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {section.bookies?.length > 0 ? (
              section.bookies.map((bookie) => (
                <BookieCard
                  key={bookie.bookie}
                  bookie={bookie}
                  onEdit={() => onEditSetting(bookie, section.id)}
                />
              ))
            ) : (
              <div className="col-span-full text-center text-[#ABCDDF] py-8">
                No bookies configuration available
              </div>
            )}
          </div>
        )
      ) : (
        /* Regular Settings Cards */
        <div className="grid gap-4 md:grid-cols-2">
          {section.settings?.map((setting) => (
            <SettingCard
              key={setting.id}
              setting={setting}
              onEdit={() => onEditSetting(setting, section.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SettingsSection; 